(function () {
  'use strict';

  /* KX DESKTOP PERSONALIZATION MODE V16
     Mobile storefront stays mobile.
     When LPO personalization = yes, emulate the desktop viewport automatically.
     No mobile sticky gallery, no 50/50 split, no touch interception.
  */

  var DESKTOP_WIDTH = 1100;
  var ROOT_CLASS = 'kx-personalization-desktop-emulation';
  var ZOOM_CLASS = 'kx-browser-zoomed';

  var touchDevice = !!(
    ('ontouchstart' in window) ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0)
  );

  /* Capture the physical/mobile state BEFORE changing the viewport. */
  var originalMobile = touchDevice && Math.min(screen.width || 9999, screen.height || 9999) <= 900;

  var viewport = document.querySelector('meta[name="viewport"]');
  var viewportWasCreated = false;

  if (!viewport) {
    viewport = document.createElement('meta');
    viewport.name = 'viewport';
    document.head.appendChild(viewport);
    viewportWasCreated = true;
  }

  var originalViewport = viewport.getAttribute('content') || '';
  var active = false;
  var baselineScale = null;
  var savedScrollY = 0;
  var baselineTimer1 = 0;
  var baselineTimer2 = 0;
  var stickyRaf = 0;
  var zoomStickyActive = false;

  function optionWrap(name) {
    var root = document.querySelector('.cl-po--options');
    return root ? root.querySelector('.cl-po--option[data-option="' + name + '"]') : null;
  }

  function personalizationValue() {
    var wrap = optionWrap('kx_personalization_enabled');
    if (!wrap) return '';

    var select = wrap.querySelector('select.cl-po--input');
    if (select) return String(select.value || '');

    var checked = wrap.querySelector('input:checked');
    return checked ? String(checked.value || '') : '';
  }

  function desiredScale() {
    var physicalWidth = Math.max(320, Math.min(screen.width || 390, screen.height || 390));
    return Math.max(0.25, Math.min(0.60, physicalWidth / DESKTOP_WIDTH));
  }

  function desktopViewportContent() {
    var scale = desiredScale().toFixed(3);
    return [
      'width=' + DESKTOP_WIDTH,
      'initial-scale=' + scale,
      'minimum-scale=0.25',
      'maximum-scale=5',
      'user-scalable=yes',
      'viewport-fit=cover'
    ].join(', ');
  }

  function setClass(name, on) {
    document.documentElement.classList.toggle(name, !!on);
    if (document.body) document.body.classList.toggle(name, !!on);
  }

  function clearOldMobileExperimentClasses() {
    [
      'kx-mobile-personalization-session',
      'kx-gallery-modal-open',
      'kx-preview-edit-mode'
    ].forEach(function (name) {
      setClass(name, false);
    });

    var info = document.querySelector("product-info[data-kx-lpo-mobile-sticky='true']");
    if (info) {
      info.classList.remove('kx-lpo-mobile-active', 'kx-lpo-mobile-keyboard');
      [
        '--kx-lpo-mobile-sticky-top',
        '--kx-lpo-mobile-current-preview-height',
        '--kx-mobile-ratio-top',
        '--kx-mobile-pricebar-top',
        '--kx-mobile-gallery-controls-top',
        '--kx-mobile-gallery-block-height',
        '--kx-mobile-personalization-bar-height'
      ].forEach(function (name) {
        info.style.removeProperty(name);
      });
    }
  }

  function captureBaseline() {
    if (!active) return;
    if (window.visualViewport) {
      baselineScale = Number(window.visualViewport.scale || 1);
    } else {
      baselineScale = 1;
    }
    syncZoomClass();
  }

  function scheduleBaseline() {
    clearTimeout(baselineTimer1);
    clearTimeout(baselineTimer2);
    baselineScale = null;
    baselineTimer1 = window.setTimeout(captureBaseline, 350);
    baselineTimer2 = window.setTimeout(captureBaseline, 900);
  }

  function galleryWrapper() {
    return document.querySelector(
      "product-info[id^='MainProduct-'] .product__media-wrapper"
    ) || document.querySelector('.product__media-wrapper');
  }

  function clearZoomStickyTop() {
    if (stickyRaf) {
      cancelAnimationFrame(stickyRaf);
      stickyRaf = 0;
    }
    zoomStickyActive = false;
    var gallery = galleryWrapper();
    if (!gallery) return;

    /* Remove only our temporary inline overrides.
       The original theme sticky rule then resumes automatically. */
    gallery.style.removeProperty('top');
    gallery.style.removeProperty('position');
    gallery.style.removeProperty('align-self');
    gallery.style.removeProperty('z-index');
  }

  function applyZoomStickyTop() {
    if (stickyRaf) return;

    stickyRaf = requestAnimationFrame(function () {
      stickyRaf = 0;

      if (!active || !window.visualViewport || !baselineScale) {
        clearZoomStickyTop();
        return;
      }

      var vv = window.visualViewport;
      var current = Number(vv.scale || baselineScale);
      var ratio = current / baselineScale;

      /*
       * Hysteresis:
       * enter zoom-sticky at a real zoom, keep it active until almost
       * exactly back at baseline. This prevents the gallery from jumping
       * upward while the user is still visibly zoomed.
       */
      if (!zoomStickyActive && Math.abs(ratio - 1) >= 0.03) {
        zoomStickyActive = true;
      } else if (zoomStickyActive && Math.abs(ratio - 1) <= 0.008) {
        zoomStickyActive = false;
      }

      if (!zoomStickyActive) {
        clearZoomStickyTop();
        return;
      }

      var gallery = galleryWrapper();
      if (!gallery) return;

      var activeMedia =
        gallery.querySelector('.product__media-item.is-active') ||
        gallery.querySelector('.product__media-item[aria-current="true"]') ||
        gallery.querySelector('.product__media-item');

      var mediaHeight = 0;
      if (activeMedia && activeMedia.getBoundingClientRect) {
        mediaHeight = Math.max(0, activeMedia.getBoundingClientRect().height || 0);
      }

      var visualTop = Math.max(0, Number(vv.offsetTop || 0));
      var visualHeight = Math.max(0, Number(vv.height || 0));

      var centerGap = 12;
      if (mediaHeight > 0 && visualHeight > mediaHeight + 24) {
        centerGap = Math.max(12, Math.round((visualHeight - mediaHeight) / 2));
      }

      gallery.style.setProperty('position', 'sticky', 'important');
      gallery.style.setProperty('top', (visualTop + centerGap) + 'px', 'important');
      gallery.style.setProperty('align-self', 'flex-start', 'important');
      gallery.style.setProperty('z-index', '2', 'important');
    });
  }

  function syncZoomClass() {
    if (!active || !window.visualViewport || !baselineScale) {
      setClass(ZOOM_CLASS, false);
      return;
    }

    var current = Number(window.visualViewport.scale || baselineScale);
    var ratio = current / baselineScale;

    if (!zoomStickyActive && Math.abs(ratio - 1) >= 0.03) {
      zoomStickyActive = true;
    } else if (zoomStickyActive && Math.abs(ratio - 1) <= 0.008) {
      zoomStickyActive = false;
    }

    setClass(ZOOM_CLASS, zoomStickyActive);
    applyZoomStickyTop();
  }

  function enableDesktopPersonalization() {
    if (!originalMobile || active) return;

    active = true;
    savedScrollY = window.scrollY || window.pageYOffset || 0;

    clearOldMobileExperimentClasses();
    clearZoomStickyTop();
    setClass(ROOT_CLASS, true);
    setClass(ZOOM_CLASS, false);

    viewport.setAttribute('content', desktopViewportContent());

    /* Let responsive CSS and Cloudlift recalculate against the desktop width. */
    try { window.dispatchEvent(new Event('resize')); } catch (_) {}
    scheduleBaseline();

    window.setTimeout(function () {
      try { window.dispatchEvent(new Event('resize')); } catch (_) {}
    }, 120);

    window.setTimeout(function () {
      try { window.dispatchEvent(new Event('resize')); } catch (_) {}
    }, 500);
  }

  function disableDesktopPersonalization() {
    if (!active) return;

    active = false;
    baselineScale = null;
    clearTimeout(baselineTimer1);
    clearTimeout(baselineTimer2);

    setClass(ZOOM_CLASS, false);
    setClass(ROOT_CLASS, false);
    clearZoomStickyTop();

    if (viewportWasCreated && !originalViewport) {
      viewport.remove();
    } else {
      viewport.setAttribute('content', originalViewport);
    }

    try { window.dispatchEvent(new Event('resize')); } catch (_) {}

    window.setTimeout(function () {
      try { window.scrollTo(0, savedScrollY); } catch (_) {}
      try { window.dispatchEvent(new Event('resize')); } catch (_) {}
    }, 180);
  }

  function sync() {
    if (!originalMobile) return;

    var shouldUseDesktop = personalizationValue() === 'yes';

    if (shouldUseDesktop) enableDesktopPersonalization();
    else disableDesktopPersonalization();

    if (active) syncZoomClass();
  }

  window.addEventListener('options:rendered', function () {
    window.setTimeout(sync, 30);
  });

  window.addEventListener('option:changed', function () {
    window.setTimeout(sync, 20);
  });

  window.addEventListener('option:variant_changed', function () {
    window.setTimeout(sync, 80);
  });

  window.addEventListener('kx:personalization-closed', function () {
    disableDesktopPersonalization();
  });

  window.addEventListener('kx:personalization-restored', function () {
    window.setTimeout(sync, 40);
  });

  document.addEventListener('input', function (event) {
    if (event.target && event.target.closest && event.target.closest('.cl-po--options')) {
      window.setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('.cl-po--options')) {
      window.setTimeout(sync, 0);
    }
  }, true);

  window.addEventListener('pageshow', function () {
    window.setTimeout(sync, 60);
  });

  window.addEventListener('orientationchange', function () {
    if (!active) return;
    window.setTimeout(function () {
      viewport.setAttribute('content', desktopViewportContent());
      scheduleBaseline();
      try { window.dispatchEvent(new Event('resize')); } catch (_) {}
    }, 180);
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncZoomClass, { passive: true });
    window.visualViewport.addEventListener('scroll', syncZoomClass, { passive: true });
  }

  window.addEventListener('scroll', function () {
    if (active) applyZoomStickyTop();
  }, { passive: true });

  /* Small fallback check; no MutationObserver. */
  window.setInterval(sync, 700);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(sync, 60);
    }, { once: true });
  } else {
    window.setTimeout(sync, 60);
  }

  /* KX V16 — remove only explicitly unselected line-item properties. */
  function isEmptyPropertyValue(value) {
    if (typeof File !== 'undefined' && value instanceof File) {
      return !value.name && !value.size;
    }

    var v = String(value == null ? '' : value).trim().toLowerCase();
    return (
      v === '' ||
      v === 'no' ||
      v === 'false' ||
      v === 'none' ||
      v === 'off' ||
      v === 'null' ||
      v === 'undefined'
    );
  }

  function cleanFormDataProperties(formData) {
    if (!formData || typeof formData.entries !== 'function') return;

    Array.from(formData.entries()).forEach(function (entry) {
      var key = entry[0];
      var value = entry[1];

      if (!/^properties\[.+\]$/.test(key)) return;
      if (isEmptyPropertyValue(value)) {
        formData.delete(key);
      }
    });
  }

  function bindPropertyCleaner() {
    document.querySelectorAll('product-form form, form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.kxMeaningfulPropertiesBound === '1') return;
      form.dataset.kxMeaningfulPropertiesBound = '1';

      form.addEventListener('formdata', function (event) {
        cleanFormDataProperties(event.formData);
      });
    });
  }

  function cartPropertyKey(row) {
    var dt = row && row.querySelector ? row.querySelector('dt') : null;
    if (!dt) return '';
    return String(dt.textContent || '').replace(/:\s*$/, '').trim();
  }

  function cartPropertyValue(row) {
    var dd = row && row.querySelector ? row.querySelector('dd') : null;
    return dd ? String(dd.textContent || '').trim() : '';
  }

  function isKxPropertyKey(key) {
    return /^(kx_|express_)/i.test(String(key || ''));
  }

  function hideTechnicalCartProperty(key, value) {
    var k = String(key || '');
    var v = String(value || '').trim().toLowerCase();

    if (isEmptyPropertyValue(v)) return true;
    if (k === 'kx_personalization_enabled') return true;
    if (k === 'kx_layout_mode') return true;
    if (k === 'kx_consent') return true;
    if (k === 'kx_front_text_enabled' || k === 'kx_back_text_enabled') return true;
    if (/_enabled_row$/i.test(k)) return true;
    if (/^kx_business_frame_\d+_enabled$/i.test(k)) return true;
    if (k === 'kx_business_frames_enabled') return true;
    if (k === 'kx_mode' && v === 'standard') return true;

    return false;
  }

  function friendlyPropertyLabel(key) {
    var k = String(key || '');
    var m;

    m = k.match(/^kx_(front|back)_text_(\d+)_(value|font|type)$/i);
    if (m) {
      var side = m[1].toLowerCase() === 'front' ? 'Přední' : 'Zadní';
      var n = m[2];
      var what = m[3].toLowerCase();

      if (what === 'value') return side + ' · Text ' + n;
      if (what === 'font') return side + ' · Text ' + n + ' · písmo';
      if (what === 'type') return side + ' · Text ' + n + ' · tvar';
    }

    if (/^kx_front_engraving_type$/i.test(k)) return 'Přední · gravírování';
    if (/^kx_front_engraving_color$/i.test(k)) return 'Přední · provedení';
    if (/^kx_back_engraving_type$/i.test(k)) return 'Zadní · gravírování';
    if (/^kx_back_engraving_color$/i.test(k)) return 'Zadní · provedení';
    if (/^express_production$/i.test(k)) return 'Expresní výroba';
    if (/^kx_coin_certificate_enabled$/i.test(k)) return 'Certifikát pravosti';
    if (/^kx_mode$/i.test(k)) return 'Režim';

    m = k.match(/^kx_(front|back)_(photo|logo|motif|qr|handwriting)_(.+)$/i);
    if (m) {
      var side2 = m[1].toLowerCase() === 'front' ? 'Přední' : 'Zadní';
      var kindMap = {
        photo: 'Fotografie',
        logo: 'Logo',
        motif: 'Motiv',
        qr: 'QR',
        handwriting: 'Rukopis'
      };
      return side2 + ' · ' + (kindMap[m[2].toLowerCase()] || m[2]);
    }

    var clean = k
      .replace(/^kx_/i, '')
      .replace(/^front_/i, 'Přední · ')
      .replace(/^back_/i, 'Zadní · ')
      .replace(/_/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return clean || k;
  }

  function friendlyPropertyValue(value) {
    var v = String(value || '').trim();
    var lower = v.toLowerCase();

    var map = {
      yes: 'Ano',
      straight: 'Rovný',
      arc: 'Oblouk',
      light: 'Světlé',
      dark: 'Tmavé',
      fine: 'Jemné',
      standard: 'Standard',
      slothana: 'Slothana'
    };

    return Object.prototype.hasOwnProperty.call(map, lower) ? map[lower] : v;
  }

  function decorateCartProperties() {
    document.querySelectorAll('.cart-item dl').forEach(function (dl) {
      if (dl.dataset.kxCompactPersonalization === '1') return;

      var rows = Array.from(dl.children).filter(function (node) {
        return node && node.classList && node.classList.contains('product-option');
      });

      var propertyRows = rows.filter(function (row) {
        return isKxPropertyKey(cartPropertyKey(row));
      });

      if (!propertyRows.length) return;

      dl.dataset.kxCompactPersonalization = '1';

      var selected = [];
      var previewText = '';

      propertyRows.forEach(function (row) {
        var key = cartPropertyKey(row);
        var value = cartPropertyValue(row);

        if (hideTechnicalCartProperty(key, value)) {
          row.remove();
          return;
        }

        var dt = row.querySelector('dt');
        var dd = row.querySelector('dd');

        if (dt) dt.textContent = friendlyPropertyLabel(key) + ':';
        if (dd && !dd.querySelector('a')) {
          dd.textContent = friendlyPropertyValue(value);
        }

        row.classList.add('kx-cart-personalization-row');
        row.setAttribute('data-kx-original-property', key);
        selected.push(row);

        if (!previewText && /_text_\d+_value$/i.test(key) && value) {
          previewText = friendlyPropertyValue(value);
        }
      });

      if (!selected.length) return;

      var details = document.createElement('details');
      details.className = 'kx-cart-personalization';

      var summary = document.createElement('summary');
      summary.className = 'kx-cart-personalization__summary';

      var summaryText = 'Personalizace';
      if (previewText) {
        var shortText = previewText.length > 28 ? previewText.slice(0, 28) + '…' : previewText;
        summaryText += ' · „' + shortText + '“';
      }
      summaryText += ' · ' + selected.length + ' údajů';
      summary.textContent = summaryText;

      var inner = document.createElement('dl');
      inner.className = 'kx-cart-personalization__list';

      selected.forEach(function (row) {
        inner.appendChild(row);
      });

      details.appendChild(summary);
      details.appendChild(inner);
      dl.insertAdjacentElement('afterend', details);
    });
  }

  function cartDecorateBurst() {
    [0, 80, 250, 700].forEach(function (ms) {
      window.setTimeout(decorateCartProperties, ms);
    });
  }

  bindPropertyCleaner();
  cartDecorateBurst();

  window.addEventListener('pageshow', function () {
    bindPropertyCleaner();
    cartDecorateBurst();
  });

  window.addEventListener('options:rendered', bindPropertyCleaner);

  document.addEventListener('click', function () {
    window.setTimeout(function () {
      bindPropertyCleaner();
      decorateCartProperties();
    }, 350);
  }, true);

  document.addEventListener('change', function () {
    window.setTimeout(decorateCartProperties, 350);
  }, true);

})();
